export interface Question {
  id: string;
  text: string;
  type: 'open' | 'closed' | 'followup';
  category: 'big3' | 'backup' | 'template';
  templateType?: string;
  suggested?: boolean;
}

export interface QuestionTemplate {
  id: string;
  name: string;
  description: string;
  big3Questions: string[];
  backupQuestions: string[];
  category: 'onboarding' | 'feature-feedback' | 'user-research' | 'problem-discovery' | 'competitive-analysis';
}

export const QUESTION_TEMPLATES: QuestionTemplate[] = [
  {
    id: 'onboarding',
    name: 'User Onboarding',
    description: 'Understanding new user experience and first impressions',
    big3Questions: [
      'What brought you to try our product?',
      'What was your biggest challenge in getting started?',
      'What would make you more likely to continue using the product?'
    ],
    backupQuestions: [
      'How did you discover our product?',
      'What alternatives did you consider?',
      'What was your first impression?',
      'Where did you get stuck during setup?',
      'What features are most important to you?'
    ],
    category: 'onboarding'
  },
  {
    id: 'feature-feedback',
    name: 'Feature Feedback',
    description: 'Gathering insights on specific features or functionality',
    big3Questions: [
      'How do you currently solve this problem?',
      'What would an ideal solution look like to you?',
      'What would prevent you from using this feature?'
    ],
    backupQuestions: [
      'How often do you encounter this problem?',
      'What tools do you use currently?',
      'What frustrates you most about current solutions?',
      'Who else is involved in this process?',
      'What would success look like?'
    ],
    category: 'feature-feedback'
  },
  {
    id: 'user-research',
    name: 'General User Research',
    description: 'Understanding user needs, behaviors, and motivations',
    big3Questions: [
      'What are your main goals when using this type of product?',
      'What is your biggest pain point in this area?',
      'How do you measure success in your work?'
    ],
    backupQuestions: [
      'Walk me through your typical day',
      'What tools are essential to your workflow?',
      'What would save you the most time?',
      'What keeps you up at night?',
      'How do you make decisions about new tools?'
    ],
    category: 'user-research'
  },
  {
    id: 'problem-discovery',
    name: 'Problem Discovery',
    description: 'Uncovering and validating user problems',
    big3Questions: [
      'What is the hardest part about [specific area]?',
      'When was the last time you felt frustrated with this process?',
      'If you could wave a magic wand and fix one thing, what would it be?'
    ],
    backupQuestions: [
      'How much time do you spend on this weekly?',
      'What workarounds have you created?',
      'Who else is affected by this problem?',
      'How do you currently track this?',
      'What would happen if this problem got worse?'
    ],
    category: 'problem-discovery'
  },
  {
    id: 'competitive-analysis',
    name: 'Competitive Analysis',
    description: 'Understanding competitive landscape and user preferences',
    big3Questions: [
      'What other solutions have you tried for this?',
      'What do you like most about your current solution?',
      'What would make you switch to a different tool?'
    ],
    backupQuestions: [
      'How did you choose your current solution?',
      'What features are missing from existing tools?',
      'How do you evaluate new products?',
      'What would your ideal pricing model be?',
      'Who influences your tool decisions?'
    ],
    category: 'competitive-analysis'
  }
];